import gsap from 'gsap';
import { q1O } from '../util/nE';

class FullWidthEmbed {
  constructor(el) {
   //  this.el = el;
   //  this.iframe = this.el.querySelector('iframe');
   //  const innerDoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
  }

  init() {
    //  this.buildTimelineIn()
  }

  destroy() {}
}

export default FullWidthEmbed;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/FullWidthEmbed.js
// module id = 34
// module chunks = 0